import Defs from '../../primitives/colorDefs'
import * as d3 from 'd3'
export default {

  methods: {
    
    func_TubeChart(selection, x_, y_, data_, idx) {

      this.tube.x = x_
      this.tube.y = y_
      this.tube.color = data_.D_CUM >= 0 ? 'SkyBlue' : 'Pink'
      this.tube.atColor = data_.D_CUM >= 0 ? '#44A9DF' : '#EC407A',

      this.tube.scale = d3.scaleLinear()
      .domain([0, 100])
      .rangeRound([this.tube.height, 0])

      let tube = this.tube

      Defs.setDefs_Reflections(selection, this.localId)
      Defs.setDefs_Gradients(selection, 0, 'LinearA2', tube.color, [1, 0.5, .5, 0.5], this.localId)
      Defs.setDefs_Gradients(selection, 1, 'LinearA9', tube.color, [0, 0.5, 1, 0.5], this.localId)
      
      // Start from here
      let TubeChart = selection
      .append('g')
      .attr('transform', `translate(${tube.x}, ${tube.y})`)

      // ---------------------------  Reflected Effect
      TubeChart // Reflected Box
      .append('rect')
      .attr('transform', `translate(0, ${tube.height + tube.base})`)
      .attr('width', tube.tick).attr('height', tube.base).attr('opacity', '0.75')
      .attr('fill', '#E0E0DF').attr('opacity', .5)

      TubeChart // Transparent Gradation Area
      .append('rect')
      .attr('transform', `translate(${-tube.tick / 2},${tube.height + tube.base})`)
      .attr('width', tube.tick * 2.5).attr('height', tube.base + 2)
      .attr('fill', `url(#${this.localId}__Color_Reflection)`)

      TubeChart // Shadow
      .append('ellipse')
      .attr('cx', tube.tick / 4).attr('cy', tube.height + tube.base)
      .attr('rx', (tube.tick * 1.5) / 2).attr('ry', (tube.tick * 1.5) / 3 / 2)
      .attr('fill', `url(#${this.localId}_Shadow)`)


      // --------------------------- d.tube.base Cylinder
      TubeChart // Bottom Box
      .append('rect')
      .attr('transform', `translate(0,${tube.height})`)
      .attr('width', tube.tick).attr('height', tube.base)
      .attr('fill', `url(#${this.localId}_TubeBase)`)

      TubeChart // Bottom Cap Bottom
      .append('ellipse')
      .attr('cx', tube.tick / 2) .attr('cy', tube.height + tube.base)
      .attr('rx', tube.tick / 2).attr('ry', tube.tick / 3 / 2)
      .attr('fill', `url(#${this.localId}_TubeBase)`)


      // --------------------------- Tube Cylinder
      TubeChart
      .append('rect') // Tube Cylinder Box
      .attr('width', tube.tick).attr('height', tube.height).attr('fill', `url(#${this.localId}_TubeBox)`).attr('opacity', 1)

      TubeChart // Bottom Cap
      .append('ellipse')
      .attr('cx', tube.tick / 2).attr('cy', tube.height)
      .attr('rx', tube.tick / 2).attr('ry', tube.tick / 3 / 2).attr('fill', '#E0E0DF').attr('opacity', 0.9)

      TubeChart // Top Cap
      .append('ellipse')
      .attr('cx', tube.tick / 2).attr('cy', 0)
      .attr('rx', tube.tick / 2).attr('ry', tube.tick / 3 / 2).attr('fill', `url(#${this.localId}_TubeCap)`)


      // --------------------------- Color Cylinder
      TubeChart
      .append('path') // Cyinder Box
      .attr('d', `
      M ${0} ${tube.scale(0)}
      V ${tube.scale(0)}
      C 0 ${((tube.tick/3/2)*1.25) + tube.scale(0) } ${tube.tick} ${((tube.tick/3/2)*1.25) + tube.scale(0) } ${tube.tick} ${tube.scale(0) } 
      V ${tube.scale(0)} 
      `)
      .attr('fill', `url(#${this.localId}_${tube.color}_1)`)
      .attr('opacity', .9)
      .transition()
      .duration(500)
      .attr('d', () => {
      let h_ = tube.scale(data_.A_CUM)
      let hy = tube.scale(0) 

      return `
      M ${0} ${hy}
      V ${tube.scale(data_.A_CUM)}
      C 0 ${((tube.tick/3/2)*1.25) + h_} ${tube.tick} ${((tube.tick/3/2)*1.25) + h_} ${tube.tick} ${h_} 
      V ${tube.scale(0)} 
      `
      })
    
      TubeChart // Bottom Cap
      .append('ellipse')
      .attr('cx', tube.tick / 2).attr('cy', tube.height)
      .attr('rx', tube.tick / 2).attr('ry', tube.tick / 3 / 2).attr('fill', `url(#${this.localId}_${tube.color}_1)`)

      TubeChart // Top Cap
      .append('ellipse')
      .attr('cx', tube.tick / 2).attr('cy', tube.scale(0))
      .attr('rx', tube.tick / 2).attr('ry', tube.tick / 3 / 2).attr('fill', `url(#${this.localId}_${tube.color}_0)`)
      .transition().duration(500).attr('cy', tube.scale(data_.A_CUM))

      this.tube_valueTitle(TubeChart, data_, idx )
    },



    tube_valueTitle(selection, data_, idx) {

      let tube = this.tube
      
      let tubeChart = selection
      .append('g')
      .attr('transform', `translate(.5, .5)`)

      // Progress
      tubeChart
      .append('text')
      .attr('transform', `translate(${tube.tick / 2},${tube.height + tube.textY + tube.atSize*0.35})`)
      .attr('font-size', tube.atSize).attr('fill', tube.atColor)
      .attr('text-anchor', 'middle')
      .text(`${data_.A_CUM}%`)

      // This Week
      tubeChart
      .append('text')
      .attr('transform', `translate(${tube.tick /2},${tube.scale(100) + tube.wkSize*0.35})`)
      .attr('font-size', tube.wkSize).attr('fill', tube.wkColor)
      .attr('text-anchor', 'middle')
      .text(`${data_.A_WK.toFixed(1)}%`)

      this.gmx_Line(tubeChart, tube.tick, tube.tick + 20, tube.scale(100), tube.scale(100), '#bcbcbc', .5, 1)
      tubeChart
      .append('circle')
      .attr('cx', tube.tick + 20).attr('cy', tube.scale(100))
      .attr('r', 2.5).attr('fill', '#bcbcbc')

      tubeChart
      .append('text')
      .attr('transform', `translate(${tube.tick + 26},${tube.scale(100)+1 + 10*0.35})`)
      .attr('font-size', 10).attr('fill', '#757575')
      .text(`This Week`)

      // Culmulative
      this.gmx_Line(tubeChart, tube.tick, tube.tick+10, tube.scale(data_.A_CUM), tube.scale(data_.A_CUM), '#bcbcbc', .5, 1)
      this.gmx_Line(tubeChart, tube.tick+10, tube.tick+20, tube.scale(30), tube.scale(30), '#bcbcbc', .5, 1)
      this.gmx_Line(tubeChart, tube.tick+10, tube.tick+10, tube.scale(30), tube.scale(data_.A_CUM), '#bcbcbc', .5, 1)

      tubeChart
      .append('circle')
      .attr('cx', tube.tick + 20).attr('cy', tube.scale(30))
      .attr('r', 2.5).attr('fill', '#bcbcbc')
      
      tubeChart
      .append('text')
      .attr('transform', `translate(${tube.tick + 26},${tube.scale(30) + 10*0.35})`)
      .attr('font-size', 10).attr('fill', '#757575')
      .text(`Actual Culm.`)

      this.tube_schedule(tubeChart, 'WK', tube.tick + 30, tube.scale(100), data_, idx) 
      this.tube_schedule(tubeChart, 'CUM', tube.tick + 30, tube.scale(30), data_, idx) 
    },



    tube_schedule(selection, sch_, x_, y_, data_, idx) {

      let plan = data_[`P_${sch_}`]
      let delta = data_[`D_${sch_}`]
      let lineHeight = 14

      let schedule = selection
      .append('g')
      .attr('transform', `translate(${x_}, ${y_})`)

      let tY = lineHeight
      schedule
      .append('text')
      .attr('transform', `translate(0, ${tY + 11*0.35})`)
      .attr('font-size', 11).attr('fill', '#333')
      .text('Plan '+plan.toFixed(1) + '%')

      tY = tY + lineHeight
      schedule
      .append('text')
      .attr('id', `ACT_${sch_}_${idx}`)
      .attr('transform', `translate(0, ${tY + 10*0.35})`)
      .attr('font-size', 10).attr('fill', this.gmx_deltaValue(delta))
      .text('Delta '+delta.toFixed(1) + '%')

      schedule // Icon
      .append('path')
      .attr('transform', `translate(${this.getNode(`#ACT_${sch_}_${idx}`, 'width')+2}, ${tY - 4}) scale(.6)`)
      .attr('d', this.gmx_deltaValue(delta, 'icon'))
      .attr('fill', this.gmx_deltaValue(delta))
      .attr('stroke-width', .5)
    }


  }
}
